import { render } from "./smeta_add.vue?vue&type=template&id=ff612fde"
import script from "./smeta_add.vue?vue&type=script&lang=js"
export * from "./smeta_add.vue?vue&type=script&lang=js"

import "./smeta_add.vue?vue&type=style&index=0&id=ff612fde&lang=scss"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__